import { render, staticRenderFns } from "./monitors-view.vue?vue&type=template&id=84653f0c&"
import script from "./monitors-view.vue?vue&type=script&lang=js&"
export * from "./monitors-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports